<template>
  <div class="vcv-content">
    <div class="vremarks container_ctrl">
      <el-row>
        <el-col :span="6">
          <div class="colimgmid">
            <user-avatar :src="photo" class="cirle" @click="viewUserAvatar = true"></user-avatar>
          </div>
        </el-col>
        <el-col :span="18">
          <el-row>
            <el-col :span="22">
              <b class="ta-name">{{name}}&nbsp;</b>
              <span style="border:1px solid grey;font-size:8px; color:grey;padding:2px;">ID</span>
              {{user_no}}
              <el-tooltip :content="'邀约面试奖'+interviewCoin+'乐币，录用奖'+hireCoin+'乐币'" placement="top" effect="light">
                <el-tag v-if="resumeType<3" size="mini" effect="dark" type="success">悬赏</el-tag>
              </el-tooltip>
              <!-- <el-tag v-if="hr_download" size="mini">已下载</el-tag>
              <el-tag v-if="isII" type="success" size="mini">已代约</el-tag> -->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="impmsg">
              <span v-if="sex">{{sex}}</span>
              <span v-if="birth">{{this.$Shared.calcAge(birth)}}岁</span>
              <span>{{work_year > 0 ? work_year + "年工作经验" : "工作经验未知"}}</span>
              <!-- <span v-if="resumeType>2 && hr_download"> -->
                <!-- <mobileImage :mobile="mobile"></mobileImage> -->
              <!-- </span> -->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              户&#12288;&#12288;籍：<span v-html="HighlightWord(native_city)"></span>
            </el-col>
            <el-col :span="12">
              居住地址：<span v-html="HighlightWord(live_city)"></span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              出生日期：{{this.$Shared.formatDate(birth)}}
            </el-col>
            <el-col :span="12">
              婚姻状况：{{married_status}}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="height > 0">
              身&#12288;&#12288;高：{{height}}cm
            </el-col>
            <el-col :span="12" v-if="weight > 0">
              体&#12288;&#12288;重：{{weight}}kg
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!-- 求职意向 -->
    <div class="vremarks nomargin container_ctrl" @mouseenter="workExpectIcon = true"
      @mouseleave="workExpectIcon = false">
      <h1 class="member-title member-title2"><i class="workexpecticon"></i>求职意向
      </h1>
      <div class="vinfobox">
        <el-row>
          <el-col :span="12">
            工作性质：<span v-if="job_nature"
              v-html="HighlightWord(job_nature)">{{job_nature}}</span>
          </el-col>
          <el-col :span="12">
            意向城市：<span v-if="citys" v-html="HighlightWord(citys)">{{citys}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            意向职能：<span v-if="positions"
              v-html="HighlightWord(positions)">{{positions}}</span>
          </el-col>
          <el-col :span="12">
            期望月薪：{{min_salary}}K - {{max_salary}}K
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 教育经历 -->
    <div class="vremarks nomargin" v-if="eduexps.length>0">
      <h1 class="member-title member-title2">
        <i class="eduicon"></i>教育经历
      </h1>
      <div>
        <ul>
          <li v-for="(item,index) in eduexps" :key="index" class="container_ctrl">
            <i class="remarksicon2x"></i>
            <el-row>
              <el-col :span="10">
                {{$Shared.formatDateYearMonth(item.beginDate)}} - {{$Shared.formatDateYearMonth(item.endDate)}}
                <span style="float:right"></span>
              </el-col>
              <el-col :span="10">
                <span v-if="item.school" v-html="HighlightWord(item.school)">{{item.school}}</span>
                <span style="float:right"></span>
              </el-col>
            </el-row>
            <el-row class="impmsg">
              <span v-if="item.degree" v-html="HighlightWord(item.degree)">{{item.degree}}</span>
              <span v-if="item.major" v-html="HighlightWord(item.major)">{{item.major}}</span>
              <span v-if="item.eduMode" v-html="HighlightWord(item.eduMode)">{{item.eduMode}}</span>
            </el-row>
          </li>
        </ul>
      </div>
    </div>

    <!-- 工作经历 -->
    <div class="vremarks nomargin" v-if="workexps.length>0">
      <h1 class="member-title member-title2">
        <i class="workicon"></i>工作经历
      </h1>
      <div>
        <ul>
          <li v-for="(item,index) in workexps" :key="index" class="container_ctrl">
            <i class="remarksicon2x"></i>
            <el-row>
              <el-col :span="20">
                {{$Shared.formatDateYearMonth(item.beginDate)}} - {{$Shared.formatDateYearMonth(item.endDate)}}
              </el-col>
            </el-row>
            <el-row>
              <span v-if="item.companyName" v-html="HighlightWord(item.companyName)">{{item.companyName}}</span>
            </el-row>
            <el-row>
              <el-col :span="24" class="impmsg">
                <span v-if="item.workPosition" v-html="HighlightWord(item.workPosition)">{{item.workPosition}}</span>
                <span v-if="item.department" v-html="HighlightWord(item.department)">{{item.department}}</span>
              </el-col>
            </el-row>
            <el-row class="impmsg">
              <span v-if="item.industryName" v-html="HighlightWord(item.industryName)">{{item.industryName}}</span>
              <span v-if="item.coSize">{{item.coSize}}</span>
              <span v-if="item.coEconomy" v-html="HighlightWord(item.coEconomy)">{{item.coEconomy}}</span>
            </el-row>
            <el-row class="impmsg">工作描述：</el-row>
            <el-row>
              <p class="desc clr" v-html="$Shared.replaceBreakLine(HighlightWord(item.description))"></p>
            </el-row>
          </li>
        </ul>
      </div>
    </div>

    <!-- 项目经验 -->
    <div class="vremarks nomargin" v-if="projectexps.length>0">
      <h1 class="member-title member-title2">
        <i class="projecticon"></i>项目经验
      </h1>
      <div>
        <ul>
          <li v-for="(item,index) in projectexps" :key="index" class="container_ctrl">
            <i class="remarksicon2x"></i>
            <el-row>
              <el-col :span="20">
                {{$Shared.formatDateYearMonth(item.beginDate)}} - {{$Shared.formatDateYearMonth(item.endDate)}}
              </el-col>
            </el-row>
            <el-row class="impmsg"><span v-html="HighlightWord(item.projectName)"></span></el-row>
            <el-row>
              所属公司：<span v-html="HighlightWord(item.companyName)"></span>
            </el-row>
            <el-row class="impmsg">项目描述：</el-row>
            <el-row>
              <p class="desc clr" v-html="$Shared.replaceBreakLine(HighlightWord(item.description))"></p>
            </el-row>
          </li>
        </ul>
      </div>
    </div>

    <!-- 专业技能 -->
    <div class="vremarks nomargin container_ctrl" v-if="skills">
      <h1 class="member-title member-title2">
        <i class="skillicon"></i>专业技能
      </h1>
      <div class="vinfobox">
        <p class="desc" v-html="$Shared.replaceBreakLine(HighlightWord(skills))"></p>
      </div>
    </div>

    <!-- 证书 -->
    <div class="vremarks nomargin container_ctrl" v-if="certificates">
      <h1 class="member-title member-title2">
        <i class="certificateicon"></i>证书
      </h1>
      <div class="vinfobox">
        <p class="desc" v-html="$Shared.replaceBreakLine(HighlightWord(certificates))"></p>
      </div>
    </div>

    <!-- 语言能力 -->
    <div class="vremarks nomargin container_ctrl" v-if="languageskills">
      <h1 class="member-title member-title2">
        <i class="languageicon"></i>语言能力
      </h1>
      <div class="vinfobox">
        <p class="desc" v-html="$Shared.replaceBreakLine(HighlightWord(languageskills))"></p>
      </div>
    </div>

    <!-- 自我评价 -->
    <div class="vremarks nomargin container_ctrl" v-if="selfevaluation">
      <h1 class="member-title member-title2">
        <i class="selficon"></i>自我评价
      </h1>
      <div class="vinfobox">
        <p class="desc" v-html="$Shared.replaceBreakLine(HighlightWord(selfevaluation))"></p>
      </div>
    </div>

    <!-- 附加信息——其他 -->
    <div class="vremarks nomargin container_ctrl" v-if="additionalinfo">
      <h1 class="member-title member-title2">
        <i class="hobbyicon"></i>附加信息（兴趣爱好）
      </h1>
      <div class="vinfobox">
        <p class="desc" v-html="$Shared.replaceBreakLine(HighlightWord(additionalinfo))"></p>
      </div>
    </div>

    <!-- 头像 -->
    <el-dialog append-to-body top="3vh" custom-class="preview-image" :visible.sync="viewUserAvatar">
      <img class="js-preview-image" :src="photo" />
    </el-dialog>
  </div>
</template>

<script>
  import {
    getSplitWords,
    highlightWord
  } from '~/api/common';
  import {
    letiaoResume
  } from '~/api/resume';
  import {
    getMeRewardInfo
  } from '~/api/insteadInvite';
  import userAvatar from '~/components/UserAvatar';
  import mobileImage from '~/components/MobileImage';

  export default {
    name: 'ResumeInfo',
    components: {
      userAvatar,
      mobileImage
    },
    props: {
      //Me,Ma,Mb库对应的简历ID
      resumeId: {
        type: Number,
        default: 0
      },
      //为全文搜索中的简历类型:1-乐跳可推荐，2-乐跳历史会员，3-乐跳游客 4-猎头候选人，5-O库人才(Ma...)，6-P1库人才(Mb...)
      resumeType: {
        type: Number,
        default: 0
      }, //用于显示【悬赏】标志
      isII: {
        type: Boolean
      },
      keyword: {
        type: String
      },
      jobId: {
        type: Number
      }
      // isDL: {
      //   type: Boolean
      // }
    },
    data() {
      return {
        viewUserAvatar: false,
        
        user_no: '',
        name: '',
        sexId: 0,
        me_state: 0,
        rec_state: 0,
        sex: '',
        native_city: '',
        live_city: '',
        married_status: '',
        birth: '',
        work_year: '',
        height: 0,
        weight: 0,
        photo: '',
        job_nature: '',
        positions: '',
        citys: '',
        min_salary: '',
        max_salary: '',

        eduexps: [{
          beginDate: '',
          endDate: '',
          degreeName: '',
          school: '',
          major: '',
          eduMode: ''
        }],
        workexps: [{
          beginDate: '',
          endDate: '',
          companyName: '',
          industryName: '',
          coEconomy: '',
          coSize: '',
          department: '',
          workPosition: '',
          description: ''
        }],
        projectexps: [{
          beginDate: '',
          endDate: '',
          projectName: '',
          companyName: '',
          description: ''
        }],
        skills: '',
        certificates: '',
        languageskills: '',

        selfevaluation: '',
        additionalinfo: '',
        interviewCoin: 0,
        hireCoin: 0,
        words: '',
      };
    },
    created() {
      if (this.resumeId) {
        this.getResumeInfo();
        if (this.$props.resumeType < 3) this.GetMeRewardInfo();
      }
      this.GetSplitWords();
    },
    watch: {
      // isDL: function(val){
      //   if(val){
      //     this.getBasicInfo();
      //   }
      // }
    },
    methods: {
      GetSplitWords() {
        if (this.keyword && this.keyword.length > 0) {
          var params = {
            text: this.keyword
          };
          getSplitWords(params).then(m => {
            if (m.errcode === 0) {
              this.words = m.data;
            }
          });
        }
      },
      HighlightWord(text) {
        if (text && text.length > 0 && this.words && this.words.length > 0) {
          return highlightWord(text, this.words);
        }
        return text;
      },

      GetMeRewardInfo() {
        getMeRewardInfo({
          meDataId: this.resumeId
        }).then(r => {
          if (r.errcode === 0) {
            this.interviewCoin = r.data.interviewCoin;
            this.hireCoin = r.data.hireCoin;
          }
        });
      },

      getResumeInfo(){
        var params = {
          resumeId: this.resumeId,
          resumeType: this.resumeType,
          jobId: this.jobId
        };
        letiaoResume(params).then(r => {
          if (r.errcode === 0) {
            var resume = r.data;
            if (resume) {
              this.user_no = resume.userNo;
              this.name = resume.fullName;
              this.sex = resume.sex;
              this.native_city = resume.nativeCity;
              this.live_city = resume.liveCity;
              this.married_status = resume.marriedStatus;
              this.birth = this.$Shared.formatDateYearMonth(resume.birthday);
              this.work_year = resume.workYear;
              this.photo = resume.headImage;
              this.me_state = resume.meState;
              this.rec_state = resume.recState;
              this.degreename = resume.degree;
              this.companyname = resume.currentCompany;
              this.workpostion = resume.currentPost;

              this.job_nature = resume.expectJobNature;
              this.positions = resume.expectPost;
              this.citys = resume.expectCity;
              this.min_salary = resume.expectMinSalary;
              this.max_salary = resume.expectMaxSalary;

              this.eduexps = resume.eduList;
              this.workexps = resume.workList;
              this.projectexps = resume.projectList;
              this.skills = resume.proSkill;
              this.certificates = resume.certificate;
              this.languageskills = resume.language;
              this.selfevaluation = resume.selfEvaluation;
              this.additionalinfo = resume.otherInfo;

              this.$emit('resumeLoaded', resume);
            }
          } else {
            this.$toast('简历内容读取异常，原因：' + r.errmsg);
          }
        });
      },     
    }
  };
</script>

<style scoped>
  h1 {
    margin: 5px 0 10px 0;
  }

  .el-row {
    margin-bottom: 10px;
  }

  .clr {
    color: gray;
  }
</style>